// extracted by mini-css-extract-plugin
export var closed = "_gb-1";
export var resizer = "_gb-0";